import { AgentReportState } from "./types";

export const defaultState = (): AgentReportState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    agentreports: [],
    links: {}
  };
};

export const state = defaultState();
